/* "Send us your bow" (sections/gs-service.liquid).
   A request is a $0 "Service request" order: on Send, this adds that product to the cart with the request as line
   item properties (photos upload as files and become links), then goes to checkout for contact info and the return
   address. Nothing is charged; Joey invoices from the order when the work is done.
   The shop's never-guess rule: only say what our records say. A bow that isn't on file gets
   "We don't have this record yet. We're still adding records. Text us a photo at 270-318-2020." */
(() => {
  const root = document.querySelector('[data-gss]');
  if (!root) return;
  const form = root.querySelector('[data-gss-form]');
  if (!form) return;
  const $ = (s, el = root) => el.querySelector(s);
  const $$ = (s, el = root) => [...el.querySelectorAll(s)];
  const PHONE = root.dataset.phone || '270-318-2020';
  const SMS = 'sms:+1' + PHONE.replace(/\D/g, '');
  const HANDLE = root.dataset.handle || 'service-request';
  const MAX_PHOTOS = 4;
  const MAX_SIDE = 2000;                // big phone photos are shrunk to this many pixels on the long side
  const KEEP_BYTES = 1.5 * 1024 * 1024; // a photo already this small (and no bigger than MAX_SIDE) is sent as it is
  const MAX_BYTES = 5 * 1024 * 1024;    // a photo we can't shrink here (e.g. HEIC on some computers) must be under this
  const slug = s => String(s).toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');
  const esc = s => String(s == null ? '' : s).replace(/[&<>"']/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
  const notOnFileHtml = () => 'We don\'t have this record yet. We\'re still adding records. Text us a photo at <a href="' + SMS + '">' + esc(PHONE) + '</a>.';
  const reduced = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  let data = {};
  try { data = JSON.parse($('[data-gss-data]')?.textContent || '{}'); } catch (e) { data = {}; }

  /* ---------- errors next to the problem ---------- */
  const errEl = key => $('[data-gss-err="' + key + '"]');
  const fieldsFor = {
    type: () => $$('input[name="type"]', form),
    oneida: () => [form.elements.serial, form.elements.oneida_model],
    gmodel: () => [form.elements.gmodel],
    number: () => [form.elements.number],
    other: () => [form.elements.other],
    brand: () => [form.elements.brand_model, form.elements.brand_model_pick],
    outers: () => $$('input[name="outers"]', form),
    jobs: () => $$('input[name="job"]', form),
  };
  function setErr(key, msg) {
    const e = errEl(key);
    if (e) e.textContent = msg || '';
    (fieldsFor[key] ? fieldsFor[key]() : []).forEach(f => { if (f) { if (msg) f.setAttribute('aria-invalid', 'true'); else f.removeAttribute('aria-invalid'); } });
  }
  const status = (msg, isError) => { const s = $('[data-gss-status]'); s.textContent = msg || ''; s.classList.toggle('is-error', !!isError); };

  /* ---------- 1. Your bow ---------- */
  const typeVal = () => form.querySelector('input[name="type"]:checked')?.value || '';
  const jobBox = v => form.querySelector('input[name="job"][value="' + v + '"]');
  // Oneida and G-String have their own lookups; every other listed brand shares the model + serial panel
  const panelFor = t => (t === 'oneida' || t === 'gstring' || t === 'other' || !t ? t : 'brand');
  const brandInput = () => form.querySelector('input[name="type"]:checked');
  const brandName = () => brandInput()?.dataset.brand || '';
  // other brands' models loaded in the store (Dead Wake Archery, Muzzy): a list to pick from; brands without them get a box
  const MODELS = {};
  (data.models || []).forEach(m => { (MODELS[m.brand] ||= []).push(m); });
  Object.values(MODELS).forEach(list => list.sort((a, b) => a.sort - b.sort || a.n.localeCompare(b.n)));
  const pickWrap = $('[data-gss-model-pick]');
  const textWrap = $('[data-gss-model-text]');
  const pickSel = form.elements.brand_model_pick;
  const outersBox = $('[data-gss-outers]');
  let modelsFor = '';
  function showModels(t) {
    const list = MODELS[t] || [];
    if (modelsFor !== t) {
      modelsFor = t;
      pickSel.innerHTML = '<option value="">Pick a model</option>' + list.map(m => '<option value="' + esc(m.h) + '">' + esc(m.n) + '</option>').join('') +
        '<option value="not-sure">Not sure</option><option value="other">Not on the list (type it)</option>';
    }
    pickWrap.hidden = !list.length;
    textWrap.hidden = !!list.length && pickSel.value !== 'other';
    // with a model list, the box is for a model that isn't on it, so no "LVX or VXM" suggestion there
    form.elements.brand_model.placeholder = list.length ? 'The model name on the bow' : (brandInput()?.dataset.modelHint || 'The model name on the bow');
    const hint = $('#' + form.elements.brand_model.getAttribute('aria-describedby').split(' ')[0]);
    if (hint) hint.textContent = !textWrap.hidden ? 'Don\'t know the model? Type "not sure" and add photos in step 3.'
      : 'Don\'t know the model? Pick "Not sure" and add photos in step 3.';
    // Dead Wake Archery: the outer limbs decide the yoke cables, so we ask
    const outers = list.some(m => m.outers);
    outersBox.hidden = !outers;
    if (!outers) $$('input[name="outers"]', form).forEach(r => { r.checked = false; });
  }
  pickSel.addEventListener('change', () => { setErr('brand', ''); showModels(typeVal()); askOneida(); if (pickSel.value === 'other') form.elements.brand_model.focus(); });
  $$('input[name="outers"]', form).forEach(r => r.addEventListener('change', () => setErr('outers', '')));
  const modelText = () => {
    if (pickWrap.hidden) return form.elements.brand_model.value.trim();
    const v = pickSel.value;
    if (!v) return '';
    if (v === 'not-sure') return 'Not sure';
    if (v === 'other') return form.elements.brand_model.value.trim();
    return (MODELS[typeVal()] || []).find(m => m.h === v)?.n || '';
  };
  const outersText = () => { const r = form.querySelector('input[name="outers"]:checked'); return r && !outersBox.hidden ? r.nextElementSibling.textContent.trim() : ''; };
  function showType() {
    const t = typeVal();
    $$('[data-gss-panel]').forEach(p => { p.hidden = p.dataset.gssPanel !== panelFor(t); });
    if (panelFor(t) === 'brand') showModels(t);
    // a warranty claim is for our own bows only (not the Mega-Rex: its warranty goes through Megamouth, Joey Oct 25 2026)
    const w = jobBox('warranty');
    w.disabled = t !== 'gstring';
    if (w.disabled) w.checked = false;
    setErr('type', '');
    syncJobs();
    askOneida();
  }
  $$('input[name="type"]', form).forEach(r => r.addEventListener('change', showType));
  // the brand box: "DWAI" and "Dead Wake Archery" both find it; "Something else" always shows
  const brandFilter = $('[data-gss-brand-filter]');
  const fold = s => String(s || '').toLowerCase().replace(/[^a-z0-9]+/g, ' ').trim();
  brandFilter?.addEventListener('input', () => {
    const q = fold(brandFilter.value);
    // "Muzzy VXM", "DWAI Kraken", "Oneida Osprey", "RPM bow": any real word that starts a brand's or a model's name counts
    const words = q.split(' ').filter(w => w.length > 1 && !/^bows?$/.test(w));
    let shown = 0;
    $$('.gss-brands label').forEach(l => {
      const v = l.querySelector('input').value;
      // the Oneida tile's small text says "and the rest": its names are all in data-names, so "The Hunter" doesn't bring it up
      const hay = fold(l.dataset.names + ' ' + (v === 'oneida' ? '' : l.textContent) + ' ' + (MODELS[v] || []).map(m => m.n).join(' '));
      const toks = hay.split(' ');
      const hit = l.hasAttribute('data-always') || !q || hay.includes(q) || words.some(w => toks.some(t => t.startsWith(w)));
      l.hidden = !hit && !l.querySelector('input').checked; // a picked brand never disappears
      if (hit && !l.hasAttribute('data-always')) shown++;
    });
    $('[data-gss-brand-none]').hidden = !q || shown > 0;
  });
  brandFilter?.addEventListener('keydown', e => {
    if (e.key !== 'Enter') return;
    e.preventDefault(); // Enter picks the only brand left, instead of sending the form
    const left = $$('.gss-brands label').filter(l => !l.hidden && !l.hasAttribute('data-always'));
    if (left.length === 1) { const r = left[0].querySelector('input'); r.checked = true; showType(); r.focus(); }
  });
  form.elements.brand_model.addEventListener('input', () => setErr('brand', ''));

  // Oneida: the serial reader from gstring.js (window.GSSerial), and a model list for when the serial doesn't settle it
  const serialIn = form.elements.serial;
  const modelSel = form.elements.oneida_model;
  const serialOut = $('[data-gss-serial-out]');
  let serial = null; // { raw, r } the last answer, for the current serial box
  let autoModel = ''; // the model the serial reader filled in, if any
  const PILLS = { decoded: ['ok', 'From Oneida\'s chart'], family: ['neutral', 'Year only'], years: ['neutral', 'Years only'], check: ['warn', 'Check the number'], model: ['neutral', 'Model only'], none: ['neutral', 'Not in our records'] };
  const hasModel = id => !!modelSel.querySelector('option[value="' + CSS.escape(id) + '"]');
  const modelName = id => modelSel.querySelector('option[value="' + CSS.escape(id) + '"]')?.textContent.trim() || (window.GSSerial?.name(id) || id);
  function readSerial(show = true) {
    const raw = serialIn.value.trim();
    if (!raw) {
      serial = null;
      if (show) { serialOut.replaceChildren(); setErr('oneida', 'Type the serial number first, or pick the model below.'); serialIn.focus(); }
      return null;
    }
    if (!window.GSSerial) {
      serial = null;
      if (show) serialOut.innerHTML = '<div class="gss-rec gss-rec--none"><p>The serial reader didn\'t load. Pick your model below, or text us a photo of the number at <a href="' + SMS + '">' + esc(PHONE) + '</a>.</p></div>';
      return null;
    }
    const r = window.GSSerial.decode(raw);
    if (!r) { serial = null; return null; }
    serial = { raw: raw.toUpperCase().slice(0, 24), r };
    setErr('oneida', '');
    const ids = (r.links || []).map(id => String(id).replace(/_/g, '-')).filter(hasModel);
    // the chart settles it: fill in the model (never when it allows more than one)
    let picked = '';
    if (r.conf === 'decoded' && ids.length === 1) {
      if (modelSel.value !== ids[0]) autoModel = ids[0]; // a model already picked by hand stays theirs
      modelSel.value = ids[0]; picked = ids[0];
    }
    if (!show) return serial;
    const pill = PILLS[r.conf] || PILLS.none;
    const div = document.createElement('div');
    div.className = 'gss-rec gss-fade' + (r.conf === 'decoded' ? '' : ' gss-rec--none');
    div.innerHTML = '<p class="gss-rec__top"><span class="gs-eyebrow"></span><span class="gs-pill gs-pill--' + pill[0] + '"></span></p>' +
      '<p class="gss-rec__title"></p>' + (r.year ? '<p class="gss-rec__sub"></p>' : '') + '<p data-why></p>';
    div.querySelector('.gs-eyebrow').textContent = serial.raw;
    div.querySelector('.gs-pill').textContent = pill[1];
    div.querySelector('.gss-rec__title').textContent = r.title;
    if (r.year) div.querySelector('.gss-rec__sub').textContent = 'Built ' + r.year;
    div.querySelector('[data-why]').textContent = r.why;
    // the labeled notes that aren't Oneida's chart (our shop, collectors, Oneida Labs' 1999 website), as on Find my bow:
    // the newer Osprey answer is marked "From our shop" only there (#229 b, Joey, Oct 26 2026)
    (r.notes || []).forEach(n => {
      const p = document.createElement('p');
      p.className = 'gss-rec__note';
      const b = document.createElement('b');
      b.textContent = n.label + ':';
      p.append(b, ' ' + n.text);
      div.append(p);
    });
    if (picked) {
      const p = document.createElement('p');
      p.textContent = 'We set the model below to ' + modelName(picked) + '.';
      div.append(p);
    } else if (ids.length > 1) {
      const p = document.createElement('p');
      p.textContent = 'Which one is yours? Pick it below, or tap one:';
      const box = document.createElement('div');
      box.className = 'gss-picks';
      ids.forEach(id => {
        const b = document.createElement('button');
        b.type = 'button';
        b.className = 'gss-ghost gss-ghost--sm';
        b.textContent = modelName(id);
        b.addEventListener('click', () => { modelSel.value = id; autoModel = ''; setErr('oneida', ''); modelSel.focus(); });
        box.append(b);
      });
      div.append(p, box);
    }
    serialOut.replaceChildren(div);
    return serial;
  }
  $('[data-gss-serial-go]').addEventListener('click', () => readSerial(true));
  serialIn.addEventListener('keydown', e => { if (e.key === 'Enter') { e.preventDefault(); readSerial(true); } });
  // a model the reader filled in goes with that serial: a changed serial clears it (a model picked by hand stays)
  serialIn.addEventListener('input', () => {
    serial = null; serialOut.replaceChildren(); setErr('oneida', '');
    if (autoModel && modelSel.value === autoModel) modelSel.value = '';
    autoModel = '';
  });
  modelSel.addEventListener('change', () => { autoModel = ''; setErr('oneida', ''); });

  // An Oneida model typed under another brand: the form asks, and they can still send it as typed (Joey, Nov 1 2026, #363:
  // "PEOPLE GET THE AMERICAN EAGLE AND SCREAMIN EAGLE MIXED UP"; #364: "YES"). Other names: the store's search names that only
  // mean an Oneida (so not "pro", "wood" or "youth"), plus Joey's "screamer". Two models with one name (whackmaster) just aren't filled in.
  const ONEIDA_NICKNAMES = {
    h500: ['hc500', 't500'], screaming: ['screaming', 'screamin', 'screamer', 'se600', 'se689', 'lxv'], strike: ['whackmaster', 'whackmaster ii', 'whackmaster 2', 'ted nugent'],
    phantom: ['phantom 1', 'phantom i', 'whackmaster', 'whackmaster i', 'whackmaster 1', 'ted nugent'], tomcat: ['tomcat 1', 'tomcat i'], aeroforce: ['aero force', 'silver eagle', 'king kat'],
    tomcat2: ['tomcat 2', 'tomcat x80'], tomcatexp: ['tomcat 2 exp'], phantom2: ['phantom 2'], tomcat3: ['t3', 't iii', 'tomcat 3', 'tomcat x80'], tomcat3exp: ['tomcat 3 exp', 't3 exp'],
    liteforce: ['lfm', 'light force', 'liteforce'], be2: ['esc', 'be2', 'be ii', 'black eagle 2'], 'osprey-new': ['osr'], phoenix: ['phx'], switchblade: ['switch blade'],
  };
  const oneidaNames = [...modelSel.options].filter(o => o.value && o.value !== 'not-sure')
    .flatMap(o => o.textContent.replace(/\(.*?\)/g, '').split('/').concat(ONEIDA_NICKNAMES[o.value] || []).map(n => ({ id: o.value, n: fold(n) })))
    .sort((a, b) => b.n.length - a.n.length); // "Tomcat 2" before "Tomcat"
  const ONEIDA_LOOSE = /^(oneida|bow|bows|compound|old|older|my|the|a|an|eagle)$/; // words that don't change which bow it is
  const ONEIDA_COMMON = /^(hawk|falcon|talon|kestrel|osprey|phantom|phoenix|tomcat|discovery|switchblade|screaming|screamer|esc|t3|lxv|phx|osr|lfm|t500)$/; // other makers and plain words use these too: "Hoyt Phantom", "Monster Phoenix", "Bowtech ESC"
  const ONEIDA_FAMILY = /^(tomcat|phantom)$/; // a plain "Tomcat" could be any of them, and they take different strings: they pick
  function oneidaModelIn(text) {
    const t = ' ' + fold(text).replace(/\b([a-z]{1,2}) (\d)/g, '$1$2') + ' '; // "H-250" and "SE 600" read as h250 and se600
    const m = oneidaNames.find(x => t.includes(' ' + x.n + ' '));
    if (!m) return null;
    const rest = t.replace(' ' + m.n + ' ', ' ').trim().split(' ').filter(w => w && !ONEIDA_LOOSE.test(w));
    if (ONEIDA_COMMON.test(m.n) && rest.some(w => !/^(\d+|i+|x80|exp|target|short|medium|long)$/.test(w))) return null;
    // only a name with nothing else beside it gets filled in for them: "Short Lite Force" isn't the Lite Force, and "Tomcat Ⅱ" isn't the Tomcat
    return { ...m, exact: !rest.length && !ONEIDA_FAMILY.test(m.n) && /^[a-z0-9 .,'-]*$/i.test(text.trim()) };
  }
  let askedOneida = null;
  function askOneida() {
    const t = typeVal();
    const box = t === 'other' ? form.elements.other : panelFor(t) === 'brand' && !textWrap.hidden ? form.elements.brand_model : null;
    let m = box && oneidaModelIn(box.value);
    if (m && (MODELS[t] || []).some(x => (' ' + fold(x.n) + ' ').includes(' ' + m.n + ' '))) m = null; // it's this brand's own model too: Monster's Phoenix
    askedOneida = m || null;
    $$('[data-gss-oneida-q]').forEach(p => { p.hidden = !m || !box || p.closest('[data-gss-panel]').hidden; });
  }
  form.elements.brand_model.addEventListener('input', askOneida);
  form.elements.other.addEventListener('input', askOneida);
  let typedFirst = ''; // what they typed before saying yes: it goes on the order as they typed it, so nothing gets lost
  $$('[data-gss-oneida-yes]').forEach(b => b.addEventListener('click', () => {
    const wasOther = typeVal() === 'other';
    const typed = (wasOther ? form.elements.other : form.elements.brand_model).value.trim();
    const typedSerial = (wasOther ? form.elements.other_serial : form.elements.brand_serial).value.trim();
    typedFirst = (wasOther ? '' : brandName() + ': ') + typed + (typedSerial ? ' · serial or number: ' + typedSerial : '');
    const ids = askedOneida?.exact ? oneidaNames.filter(x => x.n === askedOneida.n).map(x => x.id) : [];
    const fill = ids.length === 1 ? ids[0] : ''; // two Black Eagles or two Ospreys: they pick
    const r = form.querySelector('input[name="type"][value="oneida"]');
    r.checked = true;
    r.closest('label').hidden = false;
    $('[data-gss-brand-none]').hidden = true;
    showType();
    // the newest serial wins, and decides the model if it can; a model the reader set for a serial already there stays
    if (typedSerial) {
      modelSel.value = ''; autoModel = '';
      serialIn.value = typedSerial;
      serialIn.dispatchEvent(new Event('input', { bubbles: true }));
      readSerial(true);
      if (!modelSel.value) modelSel.value = fill;
    } else if (!(autoModel && modelSel.value === autoModel)) {
      modelSel.value = fill; autoModel = '';
    }
    modelSel.focus();
  }));

  // G-String: the bow's own build record (/pages/bow/<model>-<number>, public fields only)
  const gmodel = form.elements.gmodel;
  const numberIn = form.elements.number;
  const bowOut = $('[data-gss-bow-out]');
  let bow = null; // { key, model, num, raw, rec (null = not on file), error }
  // the shop's numbers: 1285, or letters then digits like JC067 and W012 (leading zeros only matter after letters)
  function bowNumber(raw) {
    let s = String(raw || '').trim().toUpperCase().replace(/^(G-?REX|GNAT|PRO ?2G|GSB)\s*/, '').replace(/^#/, '').replace(/\s+/g, '');
    s = s.replace(/^(JC|W)([0-9O]+)$/, (_, p, n) => p + n.replace(/O/g, '0')); // JCO67 typed for JC067
    if (/^[0-9]{1,6}$/.test(s)) return String(parseInt(s, 10));
    return /^(JC|W)[0-9]{1,6}$/.test(s) ? s : '';
  }
  const typedNumber = () => numberIn.value.trim().replace(/^#/, '').replace(/^(G-?REX|GNAT|PRO ?2G|GSB)\s*/i, '').trim();
  const FIELDS = [['hand', 'Hand'], ['draw_length', 'Draw', '″'], ['string_length', 'String', '″'], ['outboards', 'Outboards'], ['power_limbs', 'Power limbs'],
    ['generation', 'Generation'], ['cable_set', 'Cable set'], ['brace_height', 'Brace height', '″'], ['tip_to_tip', 'Tip to tip', '″']];
  const val = (rec, f) => { const v = rec[f[0]]; return v == null || String(v).trim() === '' ? '' : String(v).trim() + (f[2] && !/[″"]$/.test(String(v).trim()) ? f[2] : ''); };
  // where the string length comes from, when it isn't this bow's own build record
  function stringFrom(rec) {
    if (!rec.string_length) return '';
    if (rec.string_source === 'String chart') return 'from our ' + rec.model + ' string chart';
    if (rec.string_source === 'G-String shop spec') return 'G-String shop spec';
    if (rec.string_source === 'G-String shop spec (nearest draw)') return 'G-String shop spec for the nearest draw length';
    return '';
  }
  async function lookupBow({ show = true } = {}) {
    const model = gmodel.value;
    const raw = typedNumber();
    let bad = false;
    if (!model) { setErr('gmodel', 'Pick G-Rex, Gnat, Pro2G or GSB. The same number means a different bow on each.'); bad = true; }
    if (!raw) { setErr('number', 'Type the number under the grip, like 1285.'); bad = true; }
    if (bad) { if (show) (model ? numberIn : gmodel).focus(); return null; }
    const num = bowNumber(raw) || raw.toUpperCase();
    const key = model + '|' + num;
    if (bow && bow.key === key) { if (show) renderBow(); return bow; }
    bowOut.innerHTML = '<p class="gss-hint">Looking it up…</p>';
    let rec = null;
    let error = false;
    // GSB records aren't online yet; a number in some other shape can't be on file either
    if (model !== 'GSB' && bowNumber(raw)) {
      try {
        const res = await fetch('/pages/bow/' + slug(model) + '-' + slug(num) + '?section_id=gs-bow-record', { headers: { Accept: 'text/html' } });
        if (res.ok) {
          const doc = new DOMParser().parseFromString(await res.text(), 'text/html');
          const s = doc.querySelector('script[data-gs-bow-record]');
          if (s) rec = JSON.parse(s.textContent);
        } else if (res.status !== 404) error = true;
      } catch (e) { error = true; }
    }
    // the boxes may have changed while we waited
    if (gmodel.value !== model || typedNumber() !== raw) return lookupBow({ show });
    bow = { key, model, num, raw, rec, error };
    renderBow();
    return bow;
  }
  function renderBow() {
    if (!bow) { bowOut.replaceChildren(); return; }
    const div = document.createElement('div');
    const title = bow.model + ' #' + bow.num;
    if (bow.rec) {
      const rec = bow.rec;
      const rows = FIELDS.map(f => [f[1], val(rec, f)]).filter(r => r[1]);
      div.className = 'gss-rec gss-fade';
      div.innerHTML = '<p><span class="gss-rec__title"></span> · our build record</p>' +
        (rows.length ? '<dl>' + rows.map(r => '<div><dt>' + esc(r[0]) + '</dt><dd>' + esc(r[1]) + '</dd></div>').join('') + '</dl>'
          : '<p>Our build record for this bow doesn\'t list its specs yet.</p>');
      div.querySelector('.gss-rec__title').textContent = (rec.model || bow.model) + ' #' + (rec.number || bow.num);
      const from = stringFrom(rec);
      if (from) {
        const p = document.createElement('p');
        p.textContent = 'String length: ' + from + (rec.string_source === 'String chart' ? '. This bow\'s own build record doesn\'t list its string.' : '.');
        div.append(p);
      }
      if ((rec.model || bow.model) === 'Gnat' && rec.string_length) {
        const p = document.createElement('p');
        p.textContent = 'Gnat strings can be twisted up or down a little to fine-tune the draw length.';
        div.append(p);
      }
    } else if (bow.error) {
      div.className = 'gss-rec gss-rec--none gss-fade';
      div.innerHTML = '<p class="gss-rec__title"></p><p>We couldn\'t look it up just now. You can still send the request, or try again.</p>';
      div.querySelector('.gss-rec__title').textContent = title;
    } else {
      div.className = 'gss-rec gss-rec--none gss-fade';
      div.innerHTML = '<p class="gss-rec__title"></p><p>' + notOnFileHtml() + '</p><p>You can still send the request.</p>';
      div.querySelector('.gss-rec__title').textContent = title;
    }
    bowOut.replaceChildren(div);
  }
  $('[data-gss-bow-go]').addEventListener('click', () => lookupBow());
  numberIn.addEventListener('keydown', e => { if (e.key === 'Enter') { e.preventDefault(); lookupBow(); } });
  const bowChanged = () => { bow = null; bowOut.replaceChildren(); };
  numberIn.addEventListener('input', () => { bowChanged(); setErr('number', ''); });
  gmodel.addEventListener('change', () => { bowChanged(); setErr('gmodel', ''); });
  form.elements.other.addEventListener('input', () => setErr('other', ''));

  /* ---------- 2. What should we do? ---------- */
  const refBox = $('[data-gss-refinish]');
  const warBox = $('[data-gss-warranty]');
  function syncJobs() {
    const ref = jobBox('refinish').checked;
    refBox.hidden = !ref;
    if (ref && !lines.length) addLine(false);
    warBox.hidden = !jobBox('warranty').checked;
  }
  $$('input[name="job"]', form).forEach(c => c.addEventListener('change', e => {
    setErr('jobs', '');
    syncJobs();
    if (e.target.value === 'refinish' && e.target.checked && lines[0] && !lines[0].groups.size) lines[0].el.querySelector('input')?.focus({ preventScroll: true });
  }));

  /* Refinish: the builder's parts, finishes and colors. The shop's finish rules:
     - riser: Anodize, Powder coat, Cerakote or a pattern (as on the bow builder)
     - hardware: Anodize, Powder coat or Cerakote, never a pattern (Joey's rule)
     - outboard limbs: Anodize, Powder coat, Cerakote or a pattern
     - power limbs: Cerakote or a pattern only (never anodized or powder coated); a power-limb pattern is film dipped
     Each part's finishes come from builder_part.finishes; a solid color comes in the finishes its builder_color.finishes
     lists (blank = all of the part's). Which parts can be patterned is a section setting. A line with several parts
     offers only the finishes and colors all of them allow. */
  const NEVER = { plimbs: ['Anodize', 'Powder coat'] };
  const PATTERN_PARTS = new Set((root.dataset.patternParts || 'riser, olimbs, plimbs').split(/[\s,]+/).filter(Boolean));
  const norm = s => String(s || '').toLowerCase().replace(/[^a-z0-9]/g, '');
  // colors that mean the same thing on different parts ("Red Anodize" riser = "Red" cams), as the builder matches them
  function matchKey(c) {
    if (c.mk) return norm(c.mk);
    const words = String(c.n || '').trim().split(/\s+/);
    const fin = norm(c.f);
    if (fin && words.length > 1 && norm(words[words.length - 1]) === fin) words.pop();
    return norm(words.join(''));
  }
  function shortName(c) {
    const words = String(c.n || '').trim().split(/\s+/);
    const fin = norm(c.f);
    if (!c.p && fin && words.length > 1 && norm(words[words.length - 1]) === fin) words.pop();
    return words.join(' ');
  }
  const offeredIn = (c, f) => !c.fins || !c.fins.length || c.fins.includes(f);
  const sentence = s => { s = String(s || ''); return s.charAt(0).toUpperCase() + s.slice(1).toLowerCase(); };
  const parts = (data.parts || []).map(p => ({
    ...p,
    finishes: (p.finishes || []).filter(f => !(NEVER[p.key] || []).includes(f)),
    // the owner's rule, also when the builder data doesn't say it yet
    patternFinish: p.pattern_finish || (p.key === 'plimbs' ? 'Film dip' : ''),
    canPattern: PATTERN_PARTS.has(p.key) && (p.colors || []).some(c => c.p),
    colors: (p.colors || []).map(c => ({ ...c, m: matchKey(c), short: shortName(c) })),
  }));
  const byKey = k => parts.find(p => p.key === k);
  // the picker's part buttons, in the mockup's order
  const GROUPS = [];
  const addGroup = (code, label, ps) => { if (ps.length) GROUPS.push({ code, label, parts: ps }); };
  addGroup('riser', sentence(byKey('riser')?.name || 'Riser'), [byKey('riser')].filter(Boolean));
  addGroup('olimbs', sentence(byKey('olimbs')?.name || 'Outboard limbs'), [byKey('olimbs')].filter(Boolean));
  addGroup('hardware', 'All hardware', parts.filter(p => p.group === 'All hardware'));
  addGroup('plimbs', sentence(byKey('plimbs')?.name || 'Power limbs'), [byKey('plimbs')].filter(Boolean));

  const lines = [];
  let lineSeq = 0;
  const lineGroups = line => GROUPS.filter(g => line.groups.has(g.code));
  const lineParts = line => lineGroups(line).flatMap(g => g.parts);
  function lineFinishes(line) {
    const ps = lineParts(line);
    if (!ps.length) return [];
    const fins = ps[0].finishes.filter(f => ps.every(p => p.finishes.includes(f)));
    if (ps.every(p => p.canPattern)) fins.push('Pattern');
    return fins;
  }
  function lineColors(line) {
    const ps = lineParts(line);
    const f = line.finish;
    if (!ps.length || !f) return [];
    const pat = f === 'Pattern';
    const fits = (c, m) => (m == null || c.m === m) && !!c.p === pat && (pat || offeredIn(c, f));
    const seen = new Set();
    return ps[0].colors.filter(c => {
      if (!fits(c) || seen.has(c.m)) return false;
      if (!ps.slice(1).every(p => p.colors.some(d => fits(d, c.m)))) return false;
      seen.add(c.m);
      return true;
    });
  }
  const joinWords = a => (a.length < 2 ? a.join('') : a.slice(0, -1).join(', ') + ' and ' + a[a.length - 1]);
  const partsText = line => { const g = lineGroups(line).map((x, i) => (i ? x.label.toLowerCase() : x.label)); return joinWords(g); };
  // "Riser and all hardware: Red · Anodize", "Outboard limbs: Kryptek", "Power limbs: Kryptek · Film dip"
  function lineText(line, html) {
    const b = s => (html ? '<b>' + esc(s) + '</b>' : s);
    if (!line.groups.size) return html ? 'Pick the parts to refinish.' : '';
    const c = lineColors(line).find(x => x.m === line.color);
    if (!c) return (html ? esc(partsText(line)) : partsText(line)) + ': ' + (html ? 'pick a color.' : '');
    let what;
    if (line.finish === 'Pattern') {
      const withPf = lineGroups(line).filter(g => g.parts.every(p => p.patternFinish));
      const pfs = [...new Set(withPf.flatMap(g => g.parts.map(p => p.patternFinish)))];
      what = c.n;
      if (withPf.length && pfs.length === 1) {
        what += ' · ' + pfs[0] + (withPf.length < lineGroups(line).length ? ' on the ' + joinWords(withPf.map(g => g.label.toLowerCase())) : '');
      }
    } else {
      what = c.short + ' · ' + line.finish;
    }
    return (html ? esc(partsText(line)) : partsText(line)) + ': ' + b(what);
  }
  function renderLine(line) {
    const el = line.el;
    const fins = lineFinishes(line);
    if (!fins.includes(line.finish)) line.finish = fins[0] || '';
    const finBox = el.querySelector('[data-fin]');
    finBox.hidden = !fins.length;
    finBox.querySelector('.gss-seg').innerHTML = fins.map(f => '<label><input type="radio" name="gss-fin-' + line.id + '" value="' + esc(f) + '"' + (f === line.finish ? ' checked' : '') + '><span>' + esc(f) + '</span></label>').join('');
    const cols = lineColors(line);
    if (!cols.some(c => c.m === line.color)) line.color = '';
    const colBox = el.querySelector('[data-col]');
    colBox.hidden = !cols.length;
    colBox.querySelector('.gss-sw').innerHTML = cols.map(c => {
      const name = line.finish === 'Pattern' ? c.n : c.short;
      return '<label class="gss-swatch" title="' + esc(name) + '"><input type="radio" name="gss-col-' + line.id + '" value="' + esc(c.m) + '"' + (c.m === line.color ? ' checked' : '') + '>' +
        '<span class="gss-swatch__img" aria-hidden="true"' + (c.img ? ' style="background-image:url(\'' + esc(c.img) + '\')"' : '') + '></span><span class="gs-visually-hidden">' + esc(name) + '</span></label>';
    }).join('');
    el.querySelector('[data-text]').innerHTML = lineText(line, true);
    el.querySelector('[data-err]').textContent = '';
  }
  function renumber() {
    lines.forEach((l, i) => {
      const lg = l.el.querySelector('legend');
      lg.textContent = 'Refinish line ' + (i + 1);
      lg.classList.toggle('gs-visually-hidden', lines.length < 2);
      l.el.querySelector('[data-remove]').hidden = lines.length < 2;
    });
  }
  function addLine(focus = true) {
    const line = { id: ++lineSeq, groups: new Set(), finish: '', color: '', el: document.createElement('fieldset') };
    const el = line.el;
    el.className = 'gss-line';
    el.innerHTML = '<legend></legend>' +
      '<fieldset class="gss-sub"><legend class="gs-visually-hidden">Parts</legend><div class="gss-chips">' +
      GROUPS.map(g => '<label class="gss-chip"><input type="checkbox" value="' + g.code + '"><span>' + esc(g.label) + '</span></label>').join('') + '</div></fieldset>' +
      '<fieldset class="gss-sub" data-fin hidden><legend class="gs-visually-hidden">Finish</legend><div class="gss-seg gss-seg--fin"></div></fieldset>' +
      '<fieldset class="gss-sub" data-col hidden><legend class="gs-visually-hidden">Color</legend><div class="gss-sw"></div></fieldset>' +
      '<p class="gss-line__text" data-text aria-live="polite"></p><p class="gss-err" data-err></p>' +
      '<button type="button" class="gss-link" data-remove>Remove this line</button>';
    el.addEventListener('change', e => {
      const t = e.target;
      if (t.closest('.gss-chips')) { if (t.checked) line.groups.add(t.value); else line.groups.delete(t.value); renderLine(line); }
      else if (t.name === 'gss-fin-' + line.id) { line.finish = t.value; renderLine(line); el.querySelector('input[name="gss-fin-' + line.id + '"]:checked')?.focus(); }
      else if (t.name === 'gss-col-' + line.id) { line.color = t.value; el.querySelector('[data-text]').innerHTML = lineText(line, true); el.querySelector('[data-err]').textContent = ''; }
    });
    el.querySelector('[data-remove]').addEventListener('click', () => {
      const i = lines.indexOf(line);
      lines.splice(i, 1);
      el.remove();
      renumber();
      (lines[Math.max(0, i - 1)]?.el.querySelector('input') || $('[data-gss-addline]')).focus();
    });
    lines.push(line);
    $('[data-gss-lines]').append(el);
    renderLine(line);
    renumber();
    if (focus) el.querySelector('input')?.focus();
    return line;
  }
  $('[data-gss-addline]').addEventListener('click', () => addLine(true));
  if (!GROUPS.length) { jobBox('refinish').closest('.gss-ck')?.querySelector('small')?.append(' (tell us in the notes)'); }

  /* ---------- Refinish to look like a bow we built (Joey, Oct 20 2026: "maybe we can tap into the past build pictures
     for someone wanting their bow refinished they can choose from the past builds") ----------
     The same photos as the bow builder's "Pick from our past builds" popup: the past_build entries, as JSON from
     sections/gs-past-builds-json.liquid (up to 250 a page), loaded the first time the popup opens. Up to 4 picks of their
     own (the 4 photos in step 3 stay for the customer's bow). Each goes on the request as "Past build photo N" = its https
     address; the build sheet shows it as "Our past build: G-Rex · IMG_xxxx". The popup adds a page to the history, so
     the phone's Back closes it (a big photo first) instead of leaving the form. */
  const MAX_PAST = 4;
  const pastBox = $('[data-gss-past]');
  const pastList = $('[data-gss-past-picks]');
  const pastOpen = $('[data-gss-past-open]');
  const gal = $('[data-gss-gal]');
  const pastPicks = []; // { h, model, cap, thumb, big, link }
  let pastAll = null;   // every past build, in order: { h, model, cap, sort, w, ht, thumb, big, link }
  let pastJob = null;
  let galFilter = null; // the model shown ('' = all; null = not chosen yet)
  let galShown = [];
  let zoomAt = -1;
  let galAt = 0;
  let galPop = false;   // the popup's own history page is being taken back off (not the phone's Back)
  const tapWord = () => (window.matchMedia('(hover: hover) and (pointer: fine)').matches ? 'Click' : 'Tap');
  function loadPast() {
    if (!pastJob) {
      pastJob = (async () => {
        const out = [];
        for (let page = 1, param = '', n = 0; page && n < 40; n += 1) {
          const q = new URLSearchParams({ section_id: 'gs-past-builds-json' });
          if (param) q.set(param, String(page));
          const res = await fetch(location.pathname + '?' + q, { headers: { Accept: 'text/html' } });
          if (!res.ok) throw new Error('HTTP ' + res.status);
          const doc = new DOMParser().parseFromString(await res.text(), 'text/html');
          const json = JSON.parse(doc.querySelector('[data-gsb-past-json]').textContent);
          out.push(...json.items.filter(x => x && x.h && x.thumb && /^https:\/\//.test(x.link || '') && !out.some(o => o.h === x.h)));
          page = json.next;
          param = json.param || 'page';
        }
        pastAll = out.sort((a, b) => a.sort - b.sort);
        return pastAll;
      })().catch(err => { pastJob = null; throw err; });
    }
    return pastJob;
  }
  const pickedAt = h => pastPicks.findIndex(p => p.h === h);
  const pastSaid = (p, i, n) => 'A ' + p.model + ' we built, photo ' + (i + 1) + ' of ' + n + (p.cap ? ': ' + p.cap : '');
  // the picks under "Refinish", each with a button to take it off
  function renderPicks() {
    if (!pastList) return;
    pastList.textContent = '';
    pastPicks.forEach((p, i) => {
      const li = document.createElement('li');
      li.className = 'gss-past__pick';
      const img = document.createElement('img');
      img.src = p.thumb;
      img.alt = 'Past build photo ' + (i + 1) + ': a ' + p.model + ' we built' + (p.cap ? ', ' + p.cap : '');
      img.loading = 'lazy';
      const n = document.createElement('span');
      n.textContent = String(i + 1);
      n.setAttribute('aria-hidden', 'true');
      const x = document.createElement('button');
      x.type = 'button';
      x.textContent = '×';
      x.setAttribute('aria-label', 'Take off past build photo ' + (i + 1));
      x.addEventListener('click', () => {
        pastPicks.splice(i, 1);
        renderPicks();
        (pastList.querySelector('button') || pastOpen).focus();
      });
      li.append(img, n, x);
      pastList.append(li);
    });
    if (pastOpen) pastOpen.textContent = pastPicks.length ? 'Change past builds (' + pastPicks.length + ' of ' + MAX_PAST + ')' : 'Pick from our past builds';
    if (pastPicks.length) refBox.querySelectorAll('.gss-line [data-err]').forEach(e => { e.textContent = ''; });
  }
  function galSay(text) { $('[data-gss-gal-count]', gal).textContent = text; }
  function galTally() {
    const n = pastPicks.length;
    galSay(n ? n + ' of ' + MAX_PAST + ' picked' : tapWord() + ' a bow to pick it');
  }
  function galModels() {
    const names = pastAll.map(p => p.model);
    return names.filter((x, i) => names.indexOf(x) === i);
  }
  function renderGallery() {
    const names = galModels();
    // starts on the customer's G-String model when we have photos of it, else on All
    if (galFilter === null) galFilter = typeVal() === 'gstring' && names.includes(gmodel.value) ? gmodel.value : '';
    if (galFilter && !names.includes(galFilter)) galFilter = '';
    const filters = $('[data-gss-gal-filters]', gal);
    filters.textContent = '';
    filters.hidden = names.length < 2;
    [['', 'All', pastAll.length], ...names.map(x => [x, x, pastAll.filter(p => p.model === x).length])].forEach(([v, t, n]) => {
      const b = document.createElement('button');
      b.type = 'button';
      b.className = 'gsb-gal__filter';
      b.dataset.gssGalFilter = v;
      b.setAttribute('aria-pressed', String(v === galFilter));
      b.innerHTML = '<span></span><span class="gsb-gal__filter-n gsm-num"></span>';
      b.firstChild.textContent = t;
      b.lastChild.textContent = String(n);
      filters.append(b);
    });
    galShown = pastAll.filter(p => !galFilter || p.model === galFilter);
    const grid = $('[data-gss-gal-grid]', gal);
    grid.textContent = '';
    galShown.forEach((p, i) => {
      const li = document.createElement('li');
      li.className = 'gsb-gal__item';
      const b = document.createElement('button');
      b.type = 'button';
      b.className = 'gsb-gal__pick';
      b.dataset.gssGalPick = p.h;
      b.setAttribute('aria-label', pastSaid(p, i, galShown.length));
      const img = document.createElement('img');
      img.alt = '';
      img.loading = 'lazy';
      img.decoding = 'async';
      img.width = p.w;
      img.height = p.ht;
      img.src = p.thumb;
      const tick = document.createElement('span');
      tick.className = 'gsb-gal__tick';
      tick.setAttribute('aria-hidden', 'true');
      b.append(img, tick);
      if (p.cap) { const c = document.createElement('span'); c.className = 'gsb-gal__cap'; c.textContent = p.cap; c.setAttribute('aria-hidden', 'true'); b.append(c); }
      const see = document.createElement('button');
      see.type = 'button';
      see.className = 'gsb-gal__see';
      see.dataset.gssGalSee = String(i);
      see.setAttribute('aria-label', 'See photo ' + (i + 1) + ' bigger');
      see.innerHTML = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><circle cx="10.5" cy="10.5" r="6.5"/><path d="M15.5 15.5 21 21M10.5 7.5v6M7.5 10.5h6"/></svg>';
      li.append(b, see);
      grid.append(li);
    });
    galRove(0);
    galMarks();
  }
  // the grid is one Tab stop (a photo and its magnifier); the arrow keys move between photos
  function galRove(i, focus) {
    const picks = $$('[data-gss-gal-pick]', gal);
    if (!picks.length) return;
    galAt = Math.max(0, Math.min(picks.length - 1, i));
    picks.forEach((b, n) => { const t = n === galAt ? 0 : -1; b.tabIndex = t; b.parentElement.querySelector('[data-gss-gal-see]').tabIndex = t; });
    if (focus) picks[galAt].focus();
  }
  function galMarks() {
    const full = pastPicks.length >= MAX_PAST;
    gal.classList.toggle('is-full', full);
    $$('[data-gss-gal-pick]', gal).forEach(b => {
      const at = pickedAt(b.dataset.gssGalPick);
      b.setAttribute('aria-pressed', String(at >= 0));
      b.parentElement.classList.toggle('is-on', at >= 0);
      b.querySelector('.gsb-gal__tick').textContent = at >= 0 ? 'Photo ' + (at + 1) : '';
    });
    if (zoomAt >= 0) {
      const zp = $('[data-gss-gal-zpick]', gal);
      const at = pickedAt(galShown[zoomAt].h);
      zp.setAttribute('aria-pressed', String(at >= 0));
      zp.textContent = at >= 0 ? '✓ Picked (photo ' + (at + 1) + ')' : full ? 'You have ' + MAX_PAST + ' picked' : 'Pick this bow';
      zp.title = at >= 0 ? tapWord() + ' again to take it off' : '';
      zp.setAttribute('aria-disabled', String(at < 0 && full));
    }
    galTally();
  }
  function togglePast(h) {
    const at = pickedAt(h);
    if (at >= 0) pastPicks.splice(at, 1);
    else if (pastPicks.length >= MAX_PAST) { galSay('You have ' + MAX_PAST + ' picked, the most we take. ' + tapWord() + ' a picked one to take it off first.'); return; }
    else {
      const p = pastAll.find(x => x.h === h);
      if (!p) return;
      pastPicks.push({ h: p.h, model: p.model, cap: p.cap, thumb: p.thumb, big: p.big, link: p.link });
    }
    renderPicks();
    galMarks();
  }
  const zoomEl = () => $('[data-gss-gal-zoom]', gal);
  function galBehind(on) {
    [...gal.children].forEach(c => { if (c !== zoomEl()) c.inert = on; });
    gal.classList.toggle('is-zoom', on);
  }
  function showZoom(i) {
    if (!galShown.length) return;
    zoomAt = (i + galShown.length) % galShown.length;
    const p = galShown[zoomAt];
    const img = $('[data-gss-gal-zimg]', gal);
    img.src = p.big;
    img.alt = pastSaid(p, zoomAt, galShown.length);
    $('[data-gss-gal-zn]', gal).textContent = (zoomAt + 1) + ' of ' + galShown.length;
    $('[data-gss-gal-zcap]', gal).textContent = 'A ' + p.model + ' we built' + (p.cap ? ': ' + p.cap : '');
    const was = zoomEl().hidden;
    zoomEl().hidden = false;
    galBehind(true);
    galMarks();
    if (was) $('[data-gss-gal-zpick]', gal).focus();
  }
  function closeZoom() {
    if (zoomAt < 0) return;
    const at = zoomAt;
    zoomAt = -1;
    zoomEl().hidden = true;
    galBehind(false);
    $('[data-gss-gal-zimg]', gal).removeAttribute('src');
    $$('[data-gss-gal-see]', gal)[at]?.focus();
  }
  async function openGallery() {
    if (!gal || gal.open) return;
    gal.showModal();
    history.pushState({ gssGal: 1 }, '');
    const wait = $('[data-gss-gal-wait]', gal);
    const lead = $('[data-gss-gal-lead]', gal);
    if (lead) lead.textContent = tapWord() + ' a bow to pick it, and again to take it off. Up to ' + MAX_PAST + '.';
    if (!pastAll) {
      wait.textContent = 'Loading photos…';
      wait.hidden = false;
      galTally();
      try { await loadPast(); } catch (err) {
        wait.textContent = 'The photos didn’t load. Check your connection, then close this and try again.';
        return;
      }
      if (!gal.open) return;
    }
    wait.hidden = !!pastAll.length;
    if (!pastAll.length) wait.textContent = 'No photos here yet.';
    renderGallery();
    $('[data-gss-gal-body]', gal).scrollTop = 0;
  }
  if (gal && pastOpen) {
    pastOpen.addEventListener('click', openGallery);
    $('[data-gss-gal-close]', gal).addEventListener('click', () => gal.close());
    $('[data-gss-gal-done]', gal).addEventListener('click', () => gal.close());
    $('[data-gss-gal-zback]', gal).addEventListener('click', closeZoom);
    $('[data-gss-gal-zpick]', gal).addEventListener('click', () => { if (zoomAt >= 0) togglePast(galShown[zoomAt].h); });
    $$('[data-gss-gal-zstep]', gal).forEach(b => b.addEventListener('click', () => showZoom(zoomAt + Number(b.dataset.gssGalZstep))));
    $('[data-gss-gal-filters]', gal).addEventListener('click', e => {
      const f = e.target.closest('[data-gss-gal-filter]');
      if (!f || f.dataset.gssGalFilter === galFilter) return;
      galFilter = f.dataset.gssGalFilter;
      renderGallery();
      $('[data-gss-gal-body]', gal).scrollTop = 0;
      $('[data-gss-gal-filter][aria-pressed="true"]', gal)?.focus();
    });
    const grid = $('[data-gss-gal-grid]', gal);
    grid.addEventListener('keydown', e => {
      const li = e.target.closest('.gsb-gal__item');
      if (!li || e.altKey || e.ctrlKey || e.metaKey) return;
      const items = $$('.gsb-gal__item', grid);
      const i = items.indexOf(li);
      const cols = items.filter(x => x.offsetTop === items[0].offsetTop).length || 1;
      const to = { ArrowRight: i + 1, ArrowLeft: i - 1, ArrowDown: i + cols, ArrowUp: i - cols, Home: 0, End: items.length - 1 }[e.key];
      if (to == null) return;
      e.preventDefault();
      if (to >= 0 && to < items.length) galRove(to, true);
    });
    grid.addEventListener('focusin', e => {
      const li = e.target.closest('.gsb-gal__item');
      if (li) galRove($$('.gsb-gal__item', grid).indexOf(li));
    });
    grid.addEventListener('click', e => {
      const see = e.target.closest('[data-gss-gal-see]');
      if (see) { showZoom(Number(see.dataset.gssGalSee)); return; }
      const b = e.target.closest('[data-gss-gal-pick]');
      if (b) togglePast(b.dataset.gssGalPick);
    });
    gal.addEventListener('cancel', e => { if (zoomAt >= 0) { e.preventDefault(); closeZoom(); } });
    gal.addEventListener('keydown', e => {
      if (zoomAt >= 0 && (e.key === 'ArrowLeft' || e.key === 'ArrowRight')) { e.preventDefault(); showZoom(zoomAt + (e.key === 'ArrowLeft' ? -1 : 1)); }
    });
    let zx = null;
    let zy = null;
    const zimg = $('[data-gss-gal-zimg]', gal);
    zimg.addEventListener('pointerdown', e => { if (e.pointerType !== 'mouse') { zx = e.clientX; zy = e.clientY; } });
    zimg.addEventListener('pointerup', e => {
      if (zx == null) return;
      const dx = e.clientX - zx;
      const dy = e.clientY - zy;
      zx = zy = null;
      if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) showZoom(zoomAt + (dx < 0 ? 1 : -1));
    });
    gal.addEventListener('close', () => {
      if (zoomAt >= 0) { zoomAt = -1; zoomEl().hidden = true; galBehind(false); }
      // closed with Close, Done or Esc: take the page we added back off the history (after the phone's Back, it's gone already)
      if (history.state && history.state.gssGal) { galPop = true; history.back(); }
      pastOpen.focus({ preventScroll: true });
    });
    // the phone's Back: a big photo goes back to all the photos first, then the popup closes; the form stays
    window.addEventListener('popstate', () => {
      if (galPop) { galPop = false; return; }
      // Back or Forward onto the popup's old page while it's shut (after a reload, say): step past it
      if (!gal.open) { if (history.state && history.state.gssGal) { galPop = true; history.back(); } return; }
      if (zoomAt >= 0) { closeZoom(); history.pushState({ gssGal: 1 }, ''); return; }
      gal.close();
    });
    // a reload with the popup open leaves its page in the history: take it back off, so the next Back leaves as usual
    if (history.state && history.state.gssGal && !gal.open) { galPop = true; history.back(); }
  } else if (pastBox) pastBox.hidden = true;

  /* ---------- 3. Photos ---------- */
  const fileIn = $('[data-gss-file]');
  const thumbs = $('[data-gss-thumbs]');
  const photos = []; // { file, url, name }
  const loadImage = file => new Promise((resolve, reject) => {
    const url = URL.createObjectURL(file);
    const img = new Image();
    img.onload = () => resolve({ img, url });
    img.onerror = () => { URL.revokeObjectURL(url); reject(new Error('unreadable')); };
    img.src = url;
  });
  async function prep(file) {
    if (file.type && !/^image\//.test(file.type)) throw new Error(file.name + ' isn\'t a photo.');
    let src = null;
    let w = 0;
    let h = 0;
    let tmpUrl = '';
    try {
      if (window.createImageBitmap) { src = await createImageBitmap(file, { imageOrientation: 'from-image' }); w = src.width; h = src.height; }
    } catch (e) { src = null; }
    if (!src) {
      try { const r = await loadImage(file); src = r.img; tmpUrl = r.url; w = src.naturalWidth; h = src.naturalHeight; } catch (e) { src = null; }
    }
    if (!src || !w || !h) {
      // can't read it here (e.g. a HEIC photo on some computers): send it as it is if it's small enough
      if (file.size <= MAX_BYTES) return { file, url: '', name: file.name };
      throw new Error(file.name + ' is too big to send. Try a smaller photo, or text it to us at ' + PHONE + '.');
    }
    const scale = Math.min(1, MAX_SIDE / Math.max(w, h));
    if (scale === 1 && file.size <= KEEP_BYTES && /^image\/(jpeg|png|webp)$/.test(file.type)) {
      if (src.close) src.close();
      if (tmpUrl) URL.revokeObjectURL(tmpUrl);
      return { file, url: URL.createObjectURL(file), name: file.name };
    }
    const cw = Math.round(w * scale);
    const ch = Math.round(h * scale);
    const canvas = document.createElement('canvas');
    canvas.width = cw;
    canvas.height = ch;
    const ctx = canvas.getContext('2d');
    ctx.fillStyle = '#fff';
    ctx.fillRect(0, 0, cw, ch);
    ctx.drawImage(src, 0, 0, cw, ch);
    if (src.close) src.close();
    if (tmpUrl) URL.revokeObjectURL(tmpUrl);
    const blob = await new Promise(res => canvas.toBlob(res, 'image/jpeg', 0.85));
    if (!blob) {
      if (file.size <= MAX_BYTES) return { file, url: '', name: file.name };
      throw new Error(file.name + ' is too big to send. Try a smaller photo.');
    }
    const name = (file.name || 'photo').replace(/\.[^.]+$/, '') + '.jpg';
    const out = new File([blob], name, { type: 'image/jpeg' });
    return { file: out, url: URL.createObjectURL(out), name };
  }
  function renderPhotos() {
    thumbs.innerHTML = '';
    photos.forEach((p, i) => {
      const li = document.createElement('li');
      li.className = 'gss-thumb';
      if (p.url) {
        const img = document.createElement('img');
        img.src = p.url;
        img.alt = 'Photo ' + (i + 1) + ': ' + p.name;
        li.append(img);
      } else {
        const s = document.createElement('span');
        s.className = 'gss-thumb__name';
        s.textContent = p.name;
        li.append(s);
      }
      const x = document.createElement('button');
      x.type = 'button';
      x.className = 'gss-thumb__x';
      x.setAttribute('aria-label', 'Remove photo ' + (i + 1) + ' (' + p.name + ')');
      x.textContent = '×';
      x.addEventListener('click', () => {
        const [gone] = photos.splice(i, 1);
        if (gone && gone.url) URL.revokeObjectURL(gone.url);
        renderPhotos();
        (thumbs.querySelector('.gss-thumb__x') || fileIn).focus();
      });
      li.append(x);
      thumbs.append(li);
    });
    for (let i = photos.length; i < MAX_PHOTOS; i++) {
      const li = document.createElement('li');
      li.className = 'gss-add' + (i === photos.length ? ' gss-add--first' : '');
      li.innerHTML = '<label for="' + fileIn.id + '"><span aria-hidden="true">+</span>' + (i === photos.length ? '<span class="gs-visually-hidden">Add a photo</span>' : '') + '</label>';
      if (i !== photos.length) li.setAttribute('aria-hidden', 'true');
      thumbs.append(li);
    }
    fileIn.disabled = photos.length >= MAX_PHOTOS || !!photoJob; // off while photos are being made ready
    $('[data-gss-photo-count]').textContent = photos.length ? photos.length + ' of ' + MAX_PHOTOS + ' photos added.' : '';
  }
  // photos being made ready count toward the 4, and Send waits for them
  let photoJob = null;
  fileIn.addEventListener('change', () => {
    const files = [...fileIn.files];
    fileIn.value = '';
    if (photoJob) return; // the box is turned off while photos are being made ready
    const msgs = [];
    const room = MAX_PHOTOS - photos.length;
    if (files.length > room) msgs.push('Up to ' + MAX_PHOTOS + ' photos. ' + (room > 0 ? 'We added the first ' + room + '.' : 'Remove one to add another.'));
    errEl('photos').textContent = '';
    $('[data-gss-photo-count]').textContent = 'Getting your photos ready…';
    fileIn.disabled = true;
    photoJob = (async () => {
      try {
        for (const f of files.slice(0, Math.max(0, room))) {
          if (photos.length >= MAX_PHOTOS) break;
          try { photos.push(await prep(f)); } catch (e) { msgs.push(e.message); }
        }
      } finally {
        photoJob = null;
        renderPhotos();
        errEl('photos').textContent = msgs.join(' ');
      }
    })();
  });
  renderPhotos();

  /* ---------- 4. Send it ---------- */
  const sendBtn = $('[data-gss-send]');
  const cartNote = $('[data-gss-cartnote]');
  const sendLabel = sendBtn.textContent;
  let busy = false;
  let okWithCart = false; // the customer saw that other cart items check out together, and said go
  const setBusy = on => { busy = on; sendBtn.disabled = on; sendBtn.textContent = on ? 'Sending…' : sendLabel; form.setAttribute('aria-busy', String(on)); };
  window.addEventListener('pageshow', () => { setBusy(false); okWithCart = false; });

  async function validate() {
    const bad = [];
    ['type', 'oneida', 'gmodel', 'number', 'other', 'brand', 'outers', 'jobs'].forEach(k => setErr(k, ''));
    const t = typeVal();
    if (!t) { setErr('type', 'Pick the brand of your bow, or Something else.'); bad.push(form.querySelector('.gss-brands label:not([hidden]) input[name="type"]')); }
    if (panelFor(t) === 'brand' && !modelText()) {
      const picking = !pickWrap.hidden && pickSel.value !== 'other';
      setErr('brand', picking ? 'Pick the model, or "Not sure".' : 'Tell us the model, or type "not sure".');
      bad.push(picking ? pickSel : form.elements.brand_model);
    }
    if (panelFor(t) === 'brand' && !outersBox.hidden && !form.querySelector('input[name="outers"]:checked')) {
      setErr('outers', 'Pick the outer limbs, or "Not sure".'); bad.push(form.querySelector('input[name="outers"]'));
    }
    if (t === 'oneida') {
      if (serialIn.value.trim() && !serial) readSerial(true);
      if (!serialIn.value.trim() && !modelSel.value) { setErr('oneida', 'Type the serial number or pick the model.'); bad.push(serialIn); }
    }
    if (t === 'gstring') {
      const r = await lookupBow();
      if (!r) bad.push(!gmodel.value ? gmodel : numberIn);
    }
    if (t === 'other' && !form.elements.other.value.trim()) { setErr('other', 'Tell us the brand and model.'); bad.push(form.elements.other); }
    const jobs = $$('input[name="job"]:checked', form);
    if (!jobs.length) { setErr('jobs', 'Tick at least one.'); bad.push(form.querySelector('input[name="job"]')); }
    if (jobBox('refinish').checked) {
      if (!lines.length) addLine(false);
      lines.forEach(l => {
        // picked past builds can stand alone: a line left empty is fine then (a half-filled one still needs finishing)
        if (pastPicks.length && !l.groups.size && !l.color) { l.el.querySelector('[data-err]').textContent = ''; return; }
        const msg = !l.groups.size ? 'Pick at least one part.' : !l.color ? 'Pick a color.' : '';
        l.el.querySelector('[data-err]').textContent = msg;
        if (msg) bad.push(l.el.querySelector(!l.groups.size ? '.gss-chips input' : '.gss-sw input') || l.el.querySelector('input'));
      });
    }
    return bad;
  }

  const job = v => jobBox(v)?.checked;
  function bowText() {
    const t = typeVal();
    if (t === 'oneida') {
      const m = modelSel.value;
      return 'Oneida' + (m === 'not-sure' ? ' (not sure which model)' : m ? ' ' + modelName(m) : '');
    }
    if (t === 'gstring') return gmodel.value;
    if (panelFor(t) === 'brand') return brandName() + ': ' + modelText();
    return 'Something else: ' + form.elements.other.value.trim();
  }
  function idText() {
    const t = typeVal();
    if (t === 'oneida') return serialIn.value.trim().toUpperCase().slice(0, 24);
    if (t === 'gstring') return bow ? '#' + bow.num : typedNumber();
    if (panelFor(t) === 'brand') return form.elements.brand_serial.value.trim().toUpperCase().slice(0, 40);
    if (t === 'other') return form.elements.other_serial.value.trim().toUpperCase().slice(0, 40);
    return '';
  }
  function recordText() {
    const t = typeVal();
    if (t === 'gstring') {
      if (!bow) return 'Not looked up';
      if (bow.error) return 'Couldn\'t look it up';
      if (!bow.rec) return 'Not on file';
      const rec = bow.rec;
      const bits = FIELDS.map(f => { const v = val(rec, f); if (!v) return ''; return (f[0] === 'generation' ? '' : f[1] + ' ') + v + (f[0] === 'string_length' && stringFrom(rec) ? ' (' + stringFrom(rec) + ')' : ''); }).filter(Boolean);
      return (rec.title || bow.model + ' #' + bow.num) + ' build record' + (bits.length ? ': ' + bits.join(' · ') : ' (no specs listed)');
    }
    if (t === 'oneida') {
      if (!serial) return serialIn.value.trim() ? 'Serial not read' : 'No serial given';
      const r = serial.r;
      return 'Serial reads: ' + r.title + (r.year ? ', built ' + r.year : '') + ' (' + (PILLS[r.conf] || PILLS.none)[1].toLowerCase() + ')';
    }
    return 'Not on file';
  }
  function codes() {
    const t = typeVal();
    return {
      v: 1,
      bow: t,
      model: t === 'oneida' ? modelSel.value : t === 'gstring' ? slug(gmodel.value)
        : panelFor(t) === 'brand' ? (!pickWrap.hidden && pickSel.value && pickSel.value !== 'other' ? pickSel.value : modelText().slice(0, 80)) : '',
      outers: panelFor(t) === 'brand' && !outersBox.hidden ? form.querySelector('input[name="outers"]:checked')?.value : undefined,
      number: t === 'gstring' ? (bow ? bow.num : typedNumber()) : idText(),
      record: t === 'gstring' ? !!(bow && bow.rec) : false,
      serial_conf: t === 'oneida' && serial ? serial.r.conf : undefined,
      jobs: $$('input[name="job"]:checked', form).map(c => c.value),
      past: job('refinish') ? pastPicks.map(p => p.h) : [],
      refinish: job('refinish') ? lines.filter(l => l.groups.size && l.color).map(l => {
        const o = { parts: [...l.groups], finish: l.finish, color: l.color };
        if (l.finish === 'Pattern') { const pf = [...new Set(lineParts(l).map(p => p.patternFinish).filter(Boolean))]; if (pf.length) o.pattern_finish = pf.join('/'); }
        return o;
      }) : [],
    };
  }
  function formData() {
    const fd = new FormData();
    fd.append('id', root.dataset.variant);
    fd.append('quantity', '1');
    const P = (k, v) => { if (v != null && String(v).trim() !== '') fd.append('properties[' + k + ']', String(v).trim()); };
    P('Bow', bowText());
    P('Serial or bow number', idText());
    if (panelFor(typeVal()) === 'brand') P('Outer limbs', outersText());
    P('Our record', recordText());
    if (typeVal() === 'oneida') P('First typed as', typedFirst);
    P('Work wanted', $$('input[name="job"]:checked', form).map(c => c.dataset.label).join(', '));
    if (job('refinish')) {
      const like = pastPicks.length ? ['Make it look like our past build' + (pastPicks.length > 1 ? 's' : '') + ' (Past build photo ' + (pastPicks.length > 1 ? '1–' + pastPicks.length : '1') + ')'] : [];
      P('Refinish', like.concat(lines.map(l => lineText(l, false)).filter(s => s && !/: $/.test(s))).join('; '));
      pastPicks.forEach((p, i) => P('Past build photo ' + (i + 1), p.link));
    }
    if (job('warranty')) P('Warranty claim', 'Yes');
    P('Notes', form.elements.notes.value);
    photos.forEach((p, i) => fd.append('properties[Photo ' + (i + 1) + ']', p.file, p.name));
    P('_service', JSON.stringify(codes()));
    return fd;
  }
  const getCart = async () => { const r = await fetch('/cart.js', { headers: { Accept: 'application/json' } }); if (!r.ok) throw new Error('couldn\'t read your cart'); return r.json(); };
  function showCartNote(others) {
    const n = others.reduce((s, i) => s + (i.quantity || 1), 0);
    cartNote.innerHTML = '<p><b>Your cart has ' + n + ' other ' + (n === 1 ? 'item' : 'items') + ' in it.</b> ' + (n === 1 ? 'It checks' : 'They check') +
      ' out together with this request, and you pay for ' + (n === 1 ? 'it' : 'them') + ' as usual. The request itself is still no charge.</p>' +
      '<div class="gss-row"><a class="gss-ghost" href="' + esc(root.dataset.cart || '/cart') + '">Look at my cart</a>' +
      '<button type="button" class="gss-ghost" data-gss-go-anyway>Send it with my cart</button></div>';
    cartNote.hidden = false;
    cartNote.querySelector('[data-gss-go-anyway]').addEventListener('click', () => { okWithCart = true; cartNote.hidden = true; form.requestSubmit ? form.requestSubmit() : sendBtn.click(); });
    cartNote.querySelector('[data-gss-go-anyway]').focus();
    status('');
  }
  form.addEventListener('submit', async e => {
    e.preventDefault();
    if (busy) return;
    status('');
    setBusy(true);
    let bad;
    try { bad = await validate(); } catch (err) { bad = []; }
    if (bad.length) {
      setBusy(false);
      status(bad.length === 1 ? 'Please fix the item marked above.' : 'Please fix the ' + bad.length + ' items marked above.', true);
      bad[0].focus();
      bad[0].scrollIntoView({ behavior: reduced() ? 'auto' : 'smooth', block: 'center' });
      return;
    }
    if (photoJob) { status('Getting your photos ready…'); await photoJob; status(''); }
    try {
      if (!root.dataset.variant) throw new Error('requests aren\'t set up yet');
      const cart = await getCart();
      const items = cart.items || [];
      const mine = items.filter(i => i.handle === HANDLE);
      const others = items.filter(i => i.handle !== HANDLE);
      if (others.length && !okWithCart) { setBusy(false); showCartNote(others); return; }
      // one request per checkout: an earlier, unsent request is replaced by this one
      for (const it of mine) {
        await fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: it.key, quantity: 0 }) });
      }
      status(photos.length ? 'Sending your request and photos…' : 'Sending your request…');
      const res = await fetch('/cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body: formData() });
      if (!res.ok) {
        let body = {};
        try { body = await res.json(); } catch (x) { /* not JSON */ }
        throw new Error(body.description || body.message || 'the store said no (' + res.status + ')');
      }
      status('Going to checkout…');
      window.location.assign(root.dataset.checkout || '/checkout');
    } catch (err) {
      setBusy(false);
      status('We couldn\'t send that: ' + (err.message || 'please try again') + '. Please try again, or call or text us at ' + PHONE + '.', true);
    }
  });

  showType();
  // "Send us your bow" from a brand or model page (?brand=dwai&model=dwai-kraken): that brand and model start picked
  (() => {
    const q = new URLSearchParams(location.search);
    const qb = q.get('brand') || '', qm = q.get('model') || '';
    if (!/^[a-z0-9-]{1,40}$/.test(qb) || typeVal()) return;
    const r = $$('input[name="type"]', form).find(i => i.value === qb);
    if (!r) return;
    r.checked = true;
    showType();
    if ((MODELS[qb] || []).some(m => m.h === qm)) { pickSel.value = qm; showModels(qb); }
  })();
})();
